const articles = [
  {
    path: "/blogg/varfor-ditt-foretag-behover",
    title: "När kan ditt företag behöva hjälp med redovisningen?",
    description:
      "Skapa bättre rutiner för bokföring, underlag och uppföljning. En praktisk guide till vad du kan förbereda och ta hjälp med i företagets redovisning.",
    category: "Bokföring i vardagen",
    relatedServices: ["/LÖPANDE-BOKFÖRING", "/LÖNEADMINISTRATION", "/RÅDGIVNING"],
    introduction:
      "Kvitton, fakturor och uppföljning tar plats i företagarens vardag. Med tydliga rutiner blir det lättare att hitta rätt underlag och förstå hur verksamheten utvecklas. Här är några områden att gå igenom när du funderar på att ta hjälp med redovisningen.",
    sections: [
      {
        id: "samla-underlagen",
        title: "Samla underlagen på ett tydligt sätt",
        paragraphs: [
          "Börja med att se över var företagets kvitton, fakturor och andra underlag finns. Om materialet ligger i flera inkorgar eller mappar blir det svårare att få en samlad bild. Välj en gemensam rutin för hur nya underlag tas om hand och hur frågor om dem följs upp.",
          "Ett bra underlag hjälper den som arbetar med bokföringen att förstå affärshändelsen. Lägg till en förklaring när sammanhanget är otydligt, och samla frågor i stället för att försöka gissa hur något ska hanteras.",
        ],
      },
      {
        id: "fordela-arbetet",
        title: "Bestäm vem som gör vad",
        paragraphs: [
          "Att ta hjälp behöver inte innebära att någon annan gör allt. Du kan exempelvis samla in underlag och sköta faktureringen, medan en redovisningsbyrå hjälper till med bokföring och uppföljning. Det viktiga är att båda parter vet vad som ingår.",
        ],
        bullets: [
          "Vem samlar in kvitton och leverantörsfakturor?",
          "Vem följer upp frågor om saknade eller otydliga underlag?",
          "Hur och när går ni igenom rapporterna tillsammans?",
          "Vem kontaktar vem när något ändras i verksamheten?",
        ],
      },
      {
        id: "folj-utvecklingen",
        title: "Gör uppföljningen till en återkommande rutin",
        paragraphs: [
          "Rapporter blir mer användbara när du avsätter tid för att läsa dem. Gå igenom hur intäkter och kostnader har förändrats och skriv ned det du vill förstå bättre. En ovanlig kostnad eller en större förändring kan vara en bra utgångspunkt för samtalet med den som hjälper dig.",
          "Be om förklaringar på ett språk som fungerar för dig. Målet med uppföljningen är att du ska kunna koppla siffrorna till det som händer i företaget.",
        ],
      },
      {
        id: "anpassa-stodet",
        title: "Anpassa hjälpen när behoven förändras",
        paragraphs: [
          "Fler fakturor, nya arbetssätt eller anställda kan förändra hur mycket tid administrationen tar. Gå därför igenom arbetsfördelningen när verksamheten ändras. Beskriv vad som fungerar i dag och vilka moment som ofta blir liggande.",
          "Be om en tydlig beskrivning av omfattning och pris innan ni börjar samarbeta. Det gör det enklare att jämföra ett löpande upplägg med hjälp vid enstaka tillfällen.",
        ],
      },
      {
        id: "forbered-samtalet",
        title: "Förbered det första samtalet",
        paragraphs: [
          "Du behöver inte ha svar på allt för att ta kontakt. En kort beskrivning av företaget, dina nuvarande rutiner och det du vill få hjälp med ger en bra start. Berätta också vilket bokföringsprogram du använder och om det finns material som behöver gås igenom.",
        ],
        bullets: [
          "Beskriv verksamheten och hur du arbetar med ekonomin i dag.",
          "Samla de frågor som tar mest tid eller känns otydliga.",
          "Fundera på vad du vill sköta själv och vad du vill lämna över.",
        ],
      },
    ],
  },
  {
    path: "/blogg/thas-redovisnings-guide-to",
    title: "Rapporter, bokslut och deklaration – en översikt för småföretag",
    description:
      "Få en enkel överblick över företagets ekonomiska rapporter och hur du kan ordna underlagen inför bokslut, årsredovisning och deklaration.",
    category: "Förstå företagets ekonomi",
    relatedServices: ["/BOKSLUT", "/ÅRSREDOVISNING", "/INKOMSTDEKLARATION"],
    introduction:
      "Resultatrapport, balansrapport, bokslut och deklaration är ord som ofta dyker upp i kontakten med en redovisningsbyrå. De har olika roller. Här får du en översikt och praktiska förslag på hur du kan förbereda underlagen och ställa tydligare frågor.",
    sections: [
      {
        id: "aktuell-bokforing",
        title: "Börja med underlagen till bokföringen",
        paragraphs: [
          "Rapporterna bygger på det som har registrerats i bokföringen. Om underlag saknas eller en period ännu inte är genomgången kan rapporten ge en ofullständig bild. Fråga därför vilken period rapporten gäller och om något återstår innan du använder den i din uppföljning.",
          "Ha gärna en gemensam lista över sådant som behöver kompletteras. Det gör det tydligare vilka frågor som är öppna och vem som tar nästa steg.",
        ],
      },
      {
        id: "resultat-och-balans",
        title: "Läs resultat och balans tillsammans",
        paragraphs: [
          "Resultatrapporten visar intäkter och kostnader för en period. Balansrapporten visar tillgångar, skulder och eget kapital vid en viss tidpunkt. Tillsammans hjälper de dig att se olika delar av företagets ekonomi.",
          "Börja med förändringarna: vilka poster skiljer sig från föregående period, och vad kan förklara det? Ett resultat är heller inte samma sak som saldot på bankkontot. Be den som hjälper dig att gå igenom skillnaden med exempel från din verksamhet.",
        ],
      },
      {
        id: "forbered-bokslut",
        title: "Förbered materialet inför bokslutet",
        paragraphs: [
          "Inför bokslutet behöver årets bokföring gås igenom och kompletteras där det behövs. En tydlig överlämning sparar frågor fram och tillbaka. Kom överens med den som hjälper dig om vilket material som behövs och hur det ska lämnas över.",
        ],
        bullets: [
          "Samla underlag och frågor som fortfarande saknar svar.",
          "Gå igenom vilka kund- och leverantörsfakturor som är obetalda.",
          "Berätta om större inköp eller andra förändringar under året.",
          "Be om en lista över kompletteringar som gäller just ditt företag.",
        ],
      },
      {
        id: "arsredovisning-och-deklaration",
        title: "Håll isär årsredovisning och deklaration",
        paragraphs: [
          "Årsredovisning och deklaration är olika handlingar med olika syften. Årsredovisningen beskriver företagets ekonomi under och vid slutet av ett räkenskapsår. Deklarationen hör till redovisningen av uppgifter för beskattning. Samma uppgifter kan behöva användas på olika sätt i arbetet med dem.",
          "Vilka handlingar och underlag som är aktuella behöver bedömas utifrån ditt företag. Be om en genomgång av vad som ingår i uppdraget, vad du själv behöver bidra med och hur ni följer upp att arbetet är färdigt.",
        ],
      },
      {
        id: "fragor-till-byran",
        title: "Ta med konkreta frågor till genomgången",
        paragraphs: [
          "Du behöver inte kunna alla ekonomiska begrepp för att ha en bra dialog om rapporterna. Utgå från det du vill förstå i vardagen och be om exempel. Spara gärna era frågor och svar så att nästa uppföljning bygger vidare på den förra.",
        ],
        bullets: [
          "Är rapporten komplett för den period vi går igenom?",
          "Vilka förändringar behöver vi titta närmare på?",
          "Finns det underlag eller förklaringar jag behöver komplettera?",
          "Vilka är våra nästa steg och vem ansvarar för dem?",
        ],
      },
    ],
  },
];

export default articles;
